<div>
  <button
    [type]="to.type"
    [ngClass]="'btn btn-' + to.btnType"
    (click)="onClick($event)"
  >
    {{ to.text }}
  </button>
</div>
